<template>
  <div class="charts-outer">
    <div
      ref="container"
    >
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';

const color = [
  '#FFD103',
  '#4DA1F5',
  '#ee6666',
  '#fac858',
  '#73c0de',
  '#3ba272',
  '#fc8452',
  '#9a60b4',
  '#ea7ccc',
];

const commonOption = {
  color,
  grid: {
    top: '18%',
    left: '12%',
    right: '6%',
    bottom: '15%',
  },
  legend: {
    top: 10,
    right: 0,
  },
  tooltip: {
    trigger: 'axis',
  },
  yAxis: {
    name: '单位：人数',
    type: 'value',
  },
  xAxis: {
    data: [],
    type: 'category',
    boundaryGap: true,
    axisLabel: {
      interval: 0,
    },
  },
  series: [],
};

export default {
  name: 'LineCharts',
  data() {
    return {
      charts: null,
      renderCon: null,
    };
  },
  mounted() {
    if (this.data) {
      this.renderCharts(this.data);
    }
  },
  methods: {
    renderCharts(option, sign) {
      const options = JSON.parse(JSON.stringify(commonOption));
      const { data = [], legend = [] } = option;
      options.series = data;
      options.xAxis.data = legend;
      options.yAxis.name = sign;
      // 初始化DOM
      if (this.renderCon) {
        this.renderCon.remove();
      }
      this.renderCon = document.createElement('div');
      this.renderCon.className = 'charts-render-container';
      this.$refs.container.appendChild(this.renderCon);
      setTimeout(() => {
        const charts = echarts.init(this.renderCon);
        charts.setOption(options);
      }, 10);
    },
  },
};
</script>
<style lang="scss" scoped>
.charts-outer{
    width: 670px;
    height: 400px;
  /deep/.charts-render-container{
    width: 670px;
    height: 400px;
    margin: 0 auto;
  }
}
</style>
